import React from 'react';

interface ErrorBoundaryState {
    hasError: boolean;
    error?: Error;
}

interface ErrorBoundaryProps {
    children: React.ReactNode;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error('AOTdle Error:', error, errorInfo);
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-[#0d0d0d] p-4">
                    <div className="text-center max-w-md">
                        <div className="text-6xl mb-4">⚔️</div>
                        <h1 className="text-2xl font-bold text-[#6b9b7a] mb-2">
                            Something went wrong
                        </h1>
                        <p className="text-stone-400 mb-6">
                            The Titans have breached our defenses. Please try again.
                        </p>
                        <button
                            onClick={this.handleReload}
                            className="px-6 py-3 bg-[#4a7c59] hover:bg-[#2d5a3c] text-white font-bold rounded-lg transition-colors"
                        >
                            Reload Game
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
